import { Helpers } from '../../helpers';
import { IForecastDeclineType } from '../../interfaces/iforecast-decline-type';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastDeclineTypeBase {
  ForecastDeclineTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  TypeCurveParameters_ForecastDeclineType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastDeclineType) {
    if (item) {

      this.ForecastDeclineTypeId = item.ForecastDeclineTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.TypeCurveParameters_ForecastDeclineType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastDeclineType);
    }
  }
}